import { Dialog, DialogContent, DialogProps, DialogTitle } from '@material-ui/core';
import { Form, Formik, FormikHelpers } from 'formik';
import { CancelSubmitFormDialogActions } from 'framework/forms/CancelSubmitFormDialogActions';
import { FormDatePicker } from 'framework/forms/FormDatePicker';
import { handleFormResponse } from 'framework/forms/utils/handleFormResponse';
import { useFormSubmit } from 'framework/hooks/useFormSubmit';
import { IUndoRegisterInventoryItemAsSoldRequest, inventoryItemsCommand_undoRegisterAsSold } from 'gen/ApiClient';
import { IStrings } from 'localization/IStrings';
import { useLocalization } from 'localization/useLocalization';
import React from 'react';
import { PatientSearchProvider } from 'shared/patientSearch/PatientSearchProvider';
import { useNow } from 'shared/utils/useNow';
import * as yup from 'yup';

const createSchema = (strings: IStrings) => {
	return yup.object<IUndoRegisterInventoryItemAsSoldRequest>({
		referenceDate: yup.date().required(),
		inventoryItemId: yup.string().required(),
	});
};

interface IProps extends DialogProps {
	inventoryItemId: string;
	confirm: VoidFunction;
	cancel: VoidFunction;
}

export const InventoryItemUndoRegisterAsSoldForm = ({ confirm, cancel, inventoryItemId, ...rest }: IProps) => {
	const strings = useLocalization();
	const [submit, isSubmitting] = useFormSubmit(inventoryItemsCommand_undoRegisterAsSold);
	const now = useNow();

	const handleSubmit = async (values: IUndoRegisterInventoryItemAsSoldRequest, helpers: FormikHelpers<IUndoRegisterInventoryItemAsSoldRequest>) => {
		const r = await submit(values);
		if (handleFormResponse(r, helpers)) {
			confirm();
		}
	};

	if (now === undefined) {
		return <div></div>;
	}

	return (
		<Formik<IUndoRegisterInventoryItemAsSoldRequest>
			validateOnMount
			initialValues={{
				referenceDate: now,
				inventoryItemId: inventoryItemId,
			}}
			validationSchema={createSchema(strings)}
			onSubmit={handleSubmit}>
			<Form>
				<PatientSearchProvider>
					<Dialog
						fullWidth
						{...rest}>
						<DialogTitle>{strings.undoHistoricalSale}</DialogTitle>
						<DialogContent
							className='df-col'
							dividers>
							<FormDatePicker<IUndoRegisterInventoryItemAsSoldRequest>
								name='referenceDate'
								label={strings.referenceDate}
							/>
						</DialogContent>
						<CancelSubmitFormDialogActions
							cancel={cancel}
							isSubmitting={isSubmitting}
							submitText={strings.add}
						/>
					</Dialog>
				</PatientSearchProvider>
			</Form>
		</Formik>
	);
};
